import React, { useState } from 'react';
import { Accordion, Button, ProgressBar, Table, Badge, Tabs, Tab, Spinner } from 'react-bootstrap';
import { actualizarDatos } from '../../api/common';
import { useNavigate } from 'react-router-dom';
import Swal from 'sweetalert2';
import { useAuth } from '../../hooks/useAuth';
import DateProgram from '../Ot/DateProgram';
import { Modales } from '../Modales';
import { ContadoresOt } from '../Ot/IndicadoresOt';
import { Alertassw } from '../Alertas/Alertassw';
import ModalReprogramar from './ModalReprogramar';
import capitalizeText from '../../utils/capitalizeText';
import { useProgramacionesList } from '../../hooks/useProgramacionesList';
import FiltrosProgramaciones from './FiltrosProgramaciones';
import PaginationControls from '../commons/PaginationControls';

const ListProgramaciones = () => {
  let { userData } = useAuth();
  const navigate = useNavigate();

  // ── Hook de paginado, filtros y caché por tab ───────────────────────────
  const { activeTab, handleTabChange, tab1, tab2 } = useProgramacionesList();

  // ── Estado local de la UI (modales, reprogramar) ────────────────────────
  const [modalInfo, setModalInfo]   = useState(false);
  const [modalRep,  setModalRep]    = useState(false);
  const [ordenData, setOrdendata]   = useState({});
  const [repEntidad, setRepEntidad] = useState('programacion');
  const [repIdSelect, setRepIdSelect] = useState();


    // Aquí se cancela la progrmaciona actual
    const handleCanceled = async (item) => {
      // Advertencia si tiene avance
      if (item.avance > 0) {
        const aviso = await Swal.fire({
          title: 'Programación con avance registrado',
          text: `Esta programación tiene un avance de ${item.avance}%. Cancelarla eliminará los ítems no finalizados. ¿Deseas continuar?`,
          icon: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#d33',
          cancelButtonColor: '#6c757d',
          confirmButtonText: 'Sí, continuar',
          cancelButtonText: 'No, volver'
        });
        if (!aviso.isConfirmed) return;
      }

      const result = await Swal.fire({
        title: '¿Deseas cancelar la programación?',
        text: 'Esta acción cancelará todos los ítems de este listado que tenga estado NO FINALIZADO.',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Sí, cancelar',
        cancelButtonText: 'No, mantener'
      });
      if (!result.isConfirmed) return;

      // Preguntar si eliminar del calendario
      const calRes = await Swal.fire({
        title: '¿Eliminar del calendario?',
        text: 'Si eliminas del calendario, la visita programada ya no aparecerá en el calendario corporativo.',
        icon: 'question',
        showCancelButton: true,
        confirmButtonColor: '#d33',
        cancelButtonColor: '#3085d6',
        confirmButtonText: 'Sí, eliminar del calendario',
        cancelButtonText: 'Mantener en calendario'
      });

      try {
        const payload = {
          tipoAtualizacion: 'CANCELAR_PROGRAMACION',
          _id: item._id,
          estado: 'CANCELADO',
          fechaCancelado: new Date(),
          responsableCancelacion: userData._id,
          eliminarVisita: calRes.isConfirmed
        };
        const response = await actualizarDatos('Programacion', payload, item._id);
        if (response.status === 200) {
          Swal.fire('Cancelada', 'La programación ha sido cancelada.', 'success');
          tab1.onRefresh();
        }
      } catch (error) {
        console.error('Error al cancelar la programación:', error);
        Swal.fire('Error', 'Hubo un problema al cancelar la programación.', 'error');
      }
    }

    const infoOt=(ot)=>{
    setOrdendata(ot);
    setModalInfo(true)
  }

    const handleCerrarOt=async(ot)=>{
      const result = await Swal.fire({
        title: '¿Deseas cerrar la OT?',
        text: 'Esta acción quita la OT de la lista de OT Abiertas y solo se podrán procesar los equipos que tengan programación.',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Sí, cerrar',
        cancelButtonText: 'Cancelar'
      });
      if (!result.isConfirmed) return;

      // Preguntar si eliminar del calendario
      const calRes = await Swal.fire({
        title: '¿Eliminar del calendario?',
        text: 'Si eliminas del calendario, la visita de esta OT ya no aparecerá en el calendario corporativo.',
        icon: 'question',
        showCancelButton: true,
        confirmButtonColor: '#d33',
        cancelButtonColor: '#3085d6',
        confirmButtonText: 'Sí, eliminar del calendario',
        cancelButtonText: 'Mantener en calendario'
      });

      try {
        const payload = {
          _id: ot._id,
          otAbierta: false,
          eliminarVisita: calRes.isConfirmed
        };
        const response = await actualizarDatos('Ot', payload, ot._id);
        if (response.status === 200) {
          Alertassw('success', 'OT Cerrada correctamente');
          tab2.onRefresh();
        }
      } catch (error) {
        console.error(error);
        Swal.fire('Error', 'Error de conexión con el servidor.', 'error');
      }
    }

  const formatFecha = f => new Date(f).toLocaleString();
  const getBadgeClass = estado => ({
    PROGRAMADO: 'primary',
    "EN PROCESO": 'warning',
    FINALIZADO: 'success',
    CANCELADO: 'danger'
  })[estado] || 'secondary';


  // Abre el modal de reprogramación: ModalReprogramar gestiona la elección
  // (nueva visita / actualizar visita actual), la búsqueda de la visita vigente
  // para pre-llenar fechas y responsables, y el envío al backend.
  const handleReprogramar = (item, tipo) => {
    setRepEntidad(tipo || 'programacion');
    setRepIdSelect(item._id);
    setModalRep(true);
  };

  const handleReprogramarSuccess = () => {
    setModalRep(false);
    if (repEntidad === 'ot') tab2.onRefresh();
    else tab1.onRefresh();
  };

  return (
    <div className="container mt-3">
      <Modales
        estado={modalInfo}
        cambiarestado={setModalInfo}
        titulo={"Información de Ítems Cargados"}
      >
        <ContadoresOt ots={ordenData}/>
      </Modales>

      <ModalReprogramar
        show={modalRep}
        onClose={() => setModalRep(false)}
        onSuccess={handleReprogramarSuccess}
        entidad={repEntidad}
        idEntidad={repIdSelect}
      />

      <div className="container mt-4">
        <h3 className="mb-3 text-center fw-bold">Gestión de Programaciones</h3>
        <Tabs
          id="tabs-programaciones"
          activeKey={activeTab}
          onSelect={handleTabChange}
          className="mb-3 justify-content-center"
        >
          {/* ──────────────── Tab 1: Mis OTs (Programaciones) ──────────────── */}
          <Tab eventKey="misOT" title={`Mis OT (${tab1.data.total ?? 0})`}>
            {/* Cabecera con botón Refrescar visible arriba */}
            <div className="d-flex justify-content-end mb-2">
              <Button
                variant="outline-primary"
                size="sm"
                onClick={tab1.onRefresh}
                disabled={tab1.loading}
                title="Refrescar listado (ignora caché)"
              >
                <i className={`bi bi-arrow-clockwise me-1 ${tab1.loading ? 'spin' : ''}`}></i>
                Refrescar
              </Button>
            </div>

            {/* Filtros */}
            <FiltrosProgramaciones
              filters={tab1.filters}
              onFilterChange={tab1.onFilterChange}
              onResetFilters={tab1.onResetFilters}
              mode="programacion"
            />

            {/* Lista */}
            {tab1.loading ? (
              <div className="text-center py-4">
                <Spinner animation="border" variant="primary" />
                <p className="mt-2 text-muted">Cargando programaciones...</p>
              </div>
            ) : (
              <>
                <Accordion>
                  {(tab1.data.results || []).length === 0 ? (
                    <p className="text-center text-muted py-4">No hay programaciones que mostrar.</p>
                  ) : (
                    tab1.data.results.map((item, idx) => (
                      <Accordion.Item eventKey={idx.toString()} key={item._id}>
                        <Accordion.Header>
                          <div className="d-flex flex-column w-100">
                            <div className="d-flex justify-content-between align-items-center w-100">
                              <strong>Prog - {item.numberProgramacion} - {item.numeroOrden} - {capitalizeText(item.clientInformation?.nombre)}</strong>
                              <Badge bg={getBadgeClass(item.estado)}>{item.estado}</Badge>
                            </div>
                            <small>Fecha: {formatFecha(item.fechaInicio)} a {formatFecha(item.fechaCierre)} | <strong> Resp: {item.responsable?.nombre} {item.responsable?.apellido}</strong></small>
                            <ProgressBar now={item.avance} label={`${item.avance}%`} className="mt-1" />
                          </div>
                        </Accordion.Header>
                        <Accordion.Body>
                          <Button
                            variant="success" size="sm" className="me-2"
                            onClick={() => navigate(`/Programacion/${item._id}?&task=finalizar`)}
                          >
                            Ir a Programación
                          </Button>
                          <Button variant="light" size="sm" className="me-2 bi bi-info-square" onClick={() => infoOt(item)}>{' Info'}</Button>
                          {item.estado !== 'CANCELADO' && item.estado !== 'FINALIZADO' && (
                            <>
                              <Button variant="danger" size="sm" className="me-2" onClick={() => handleCanceled(item)}>Cancelar</Button>
                              <Button variant="warning" size="sm" className="me-2" onClick={() => handleReprogramar(item, 'programacion')}>Reprogramar</Button>
                            </>
                          )}
                          <hr />
                          <Table striped bordered responsive>
                            <thead>
                              <tr>
                                <th>Consecutivo</th><th>Ítem</th><th>Marca</th><th>Modelo</th>
                                <th>Serial</th><th>Puntos</th><th>Ubicación</th><th>Obs</th><th>Estado</th>
                              </tr>
                            </thead>
                            <tbody>
                              {item.equipos.map((eq, i) => (
                                <tr key={i}>
                                  <td>{eq.consecutivo}</td>
                                  <td>{capitalizeText(eq.snapshot?.item)}</td>
                                  <td>{eq.snapshot?.marca}</td>
                                  <td>{eq.snapshot?.modelo}</td>
                                  <td>{eq.snapshot?.serial}</td>
                                  <td>{eq.snapshot?.puntos || 'N/A'}</td>
                                  <td>
                                    <strong>{eq.snapshot?.sede || ''}</strong>
                                    <br />
                                    <small>{eq.snapshot?.ubicacion}</small>
                                  </td>
                                  <td>{eq.obs}</td>
                                  <td>{eq.estado}</td>
                                </tr>
                              ))}
                            </tbody>
                          </Table>
                          {item.eqCanceled?.length > 0 && (
                            <>
                              <div className="d-flex align-items-center gap-2 mt-3 mb-1">
                                <Badge bg="danger">Equipos Cancelados</Badge>
                                <small className="text-muted">Trazabilidad — {item.eqCanceled.length} equipo(s) retirado(s) al cancelar</small>
                              </div>
                              <Table size="sm" bordered responsive className="table-danger">
                                <thead className="table-danger">
                                  <tr>
                                    <th>Consecutivo</th><th>Ítem</th><th>Marca</th>
                                    <th>Modelo</th><th>Serial</th><th>Ubicación</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  {item.eqCanceled.map((eq, i) => (
                                    <tr key={i}>
                                      <td>{eq.consecutivo}</td>
                                      <td>{capitalizeText(eq.snapshot?.item)}</td>
                                      <td>{eq.snapshot?.marca}</td>
                                      <td>{eq.snapshot?.modelo}</td>
                                      <td>{eq.snapshot?.serial}</td>
                                      <td>
                                        <strong>{eq.snapshot?.sede || ''}</strong>
                                        <br />
                                        <small>{eq.snapshot?.ubicacion}</small>
                                      </td>
                                    </tr>
                                  ))}
                                </tbody>
                              </Table>
                            </>
                          )}
                        </Accordion.Body>
                      </Accordion.Item>
                    ))
                  )}
                </Accordion>

                {/* Paginación Tab 1 */}
                <PaginationControls
                  page={tab1.data.page || 1}
                  totalPages={tab1.data.totalPages || 0}
                  perPage={tab1.data.perPage || 20}
                  total={tab1.data.total || 0}
                  hasNextPage={tab1.data.hasNextPage || false}
                  hasPrevPage={tab1.data.hasPrevPage || false}
                  onPageChange={tab1.onPageChange}
                  onPerPageChange={tab1.onPerPageChange}
                  onRefresh={tab1.onRefresh}
                  loading={tab1.loading}
                />
              </>
            )}
          </Tab>

          {/* ──────────────── Tab 2: OTs Abiertas ──────────────── */}
          <Tab eventKey="otAbiertas" title={`OT Abiertas (${tab2.data.total ?? 0})`}>
            {/* Cabecera con botón Refrescar visible arriba */}
            <div className="d-flex justify-content-end mb-2">
              <Button
                variant="outline-primary"
                size="sm"
                onClick={tab2.onRefresh}
                disabled={tab2.loading}
                title="Refrescar listado (ignora caché)"
              >
                <i className={`bi bi-arrow-clockwise me-1 ${tab2.loading ? 'spin' : ''}`}></i>
                Refrescar
              </Button>
            </div>

            {/* Filtros */}
            <FiltrosProgramaciones
              filters={tab2.filters}
              onFilterChange={tab2.onFilterChange}
              onResetFilters={tab2.onResetFilters}
              mode="ot"
            />

            {/* Lista */}
            {tab2.loading ? (
              <div className="text-center py-4">
                <Spinner animation="border" variant="primary" />
                <p className="mt-2 text-muted">Cargando OTs abiertas...</p>
              </div>
            ) : (
              <>
                <Accordion>
                  {(tab2.data.results || []).length === 0 ? (
                    <p className="text-center text-muted py-4">No hay OTs abiertas.</p>
                  ) : (
                    tab2.data.results.map((item, idx) => (
                      <Accordion.Item eventKey={idx.toString()} key={item._id}>
                        <Accordion.Header>
                          <div className="d-flex flex-column w-100">
                            <div className="d-flex justify-content-between align-items-center w-100">
                              <strong>OT - {item.numeroOrden} - {capitalizeText(item.cliente?.nombre)}</strong>
                              <Badge bg={getBadgeClass(item.estado)}>{item.estado}</Badge>
                            </div>
                            <small>Fecha Inicio: {formatFecha(item.fechaEntrega)} a {formatFecha(item.fechaCierre)} | <strong> Lider: {item?.responsable?.nombre} {item?.responsable?.apellido}</strong></small>
                            <ProgressBar now={item.avance * 100} label={`${item.avance * 100}%`} className="mt-1" />
                          </div>
                        </Accordion.Header>
                        <Accordion.Body>
                          <Button
                            variant="success" size="sm" className="me-2"
                            onClick={() => navigate(`/Ot/${item._id}?orden=${item.numeroOrden}&task=finalizar`)}
                          >
                            Ir a Ot
                          </Button>
                          <Button variant="danger" size="sm" className="me-2" onClick={() => handleCerrarOt(item)}>Cerrar Ot</Button>
                          <Button variant="info" size="sm" className="me-2 bi bi-file-earmark-spreadsheet" onClick={() => DateProgram(item)}>{' Exportar'}</Button>
                          <Button variant="light" size="sm" className="me-2 bi bi-info-square" onClick={() => infoOt(item)}>{' Info'}</Button>
                          <Button variant="warning" size="sm" className="me-2" onClick={() => handleReprogramar(item, 'ot')}>Reprogramar</Button>
                          <hr />
                          <Table striped bordered responsive>
                            <thead>
                              <tr>
                                <th>Consecutivo</th><th>Ítem</th><th>Marca</th><th>Modelo</th>
                                <th>Serial</th><th>Puntos</th><th>Ubicación</th><th>Obs</th><th>Estado</th>
                              </tr>
                            </thead>
                            <tbody>
                              {item.equipos.map((eq, i) => (
                                <tr key={i}>
                                  <td>{eq.consecutivo}</td>
                                  <td>{capitalizeText(eq.snapshot?.item)}</td>
                                  <td>{eq.snapshot?.marca}</td>
                                  <td>{eq.snapshot?.modelo}</td>
                                  <td>{eq.snapshot?.serial}</td>
                                  <td>{eq.snapshot?.puntos || 'N/A'}</td>
                                  <td>
                                    <strong>{eq.snapshot?.sede || ''}</strong>
                                    <br />
                                    <small>{eq.snapshot?.ubicacion}</small>
                                  </td>
                                  <td>{eq.obs}</td>
                                  <td>{eq.estado}</td>
                                </tr>
                              ))}
                            </tbody>
                          </Table>
                        </Accordion.Body>
                      </Accordion.Item>
                    ))
                  )}
                </Accordion>

                {/* Paginación Tab 2 */}
                <PaginationControls
                  page={tab2.data.page || 1}
                  totalPages={tab2.data.totalPages || 0}
                  perPage={tab2.data.perPage || 20}
                  total={tab2.data.total || 0}
                  hasNextPage={tab2.data.hasNextPage || false}
                  hasPrevPage={tab2.data.hasPrevPage || false}
                  onPageChange={tab2.onPageChange}
                  onPerPageChange={tab2.onPerPageChange}
                  onRefresh={tab2.onRefresh}
                  loading={tab2.loading}
                />
              </>
            )}
          </Tab>
        </Tabs>
      </div>
    </div>
  );
};

export default ListProgramaciones;